import { useState } from 'react';
import { reset } from '@amplitude/analytics-browser';
import { kueskiAttribution } from '@kueski-dev/web-observability';
import { useAuth0 } from '@auth0/auth0-react';
import { AMPLITUDE_KUESKI } from 'Src/consts/observabilityTargets';
import { logOut as logOutService } from 'Services/Auth/SignIn';
import { cleanSession } from 'Utils/session';
import { payGTMSessionState } from 'Services/GTM/GTMSessionState';
import useHomeEventTracker from './useHomeEventTracker';

export const useLogout = () => {
  const { logout } = useAuth0();
  const [isLoggingOut, setIsLoggingOut] = useState(false);
  const [trackLoggedOut] = useHomeEventTracker.deprecated('user_logged_out');
  const homeTracker = useHomeEventTracker();

  const closeSession = async (returnTo?: string) => {
    if (isLoggingOut) return;
    setIsLoggingOut(true);

    try {
      await Promise.all([
        homeTracker.track('button_clicked', {
          attributes: { button_name: 'logout' },
          target: AMPLITUDE_KUESKI,
        }),
        trackLoggedOut(),
        logOutService(),
        kueskiAttribution.clear(),
      ]);
    } finally {
      reset();
      cleanSession();
      payGTMSessionState.clear();
      await logout({ logoutParams: { returnTo: returnTo ?? `${window.location.origin}/pay` } });
    }
  };

  return {
    closeSession,
  };
};
